import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { API, graphqlOperation } from 'aws-amplify';
import gql from 'graphql-tag';
import { IState } from '../graphql/types';
import { TranscriptItemInput } from '../graphql/api';
import { setTranscriptData } from '../actions';
import useMutation from './useMutation';
import {
  UpdateTranscriptContentInput,
  UpdateTranscriptContentMutation,
} from '../graphql/api';
import { updateTranscriptContent } from '../graphql/mutations';

const getTranscriptQuery = gql`
  query GetTranscript($giideID: String!, $recordingID: String!) {
    getTranscript(giideID: $giideID, recordingID: $recordingID) {
      transcript
    }
  }
`;

const useTranscript = (giideID: string, recordingID: string) => {
  const dispatch = useDispatch();
  const updateWordMutation = useMutation<
    UpdateTranscriptContentInput,
    UpdateTranscriptContentMutation
  >(updateTranscriptContent as string);

  const [loading, setLoading] = useState<boolean>(false);
  const [saving, setSaving] = useState<boolean>(false);

  const data = useSelector<IState, TranscriptItemInput[] | undefined>(
    state => state.transcriptData
  );

  const refetch = React.useCallback(() => {
    dispatch(setTranscriptData(undefined));

    if (!giideID || !recordingID) return;

    setLoading(true);

    (
      API.graphql(
        graphqlOperation(getTranscriptQuery, {
          giideID,
          recordingID,
        })
      ) as Promise<{ data: { getTranscript: { transcript: string } } }>
    )
      .then(result => {
        const parsed = JSON.parse(result.data.getTranscript.transcript);
        dispatch(setTranscriptData(parsed.items as TranscriptItemInput[]));
        setLoading(false);
      })
      .catch(err => console.log(err))
      .finally(() => setLoading(false));
  }, [dispatch, giideID, recordingID]);

  const updateWord = React.useCallback(
    (
      giideId: string,
      recordingID: string,
      transcriptItemID: string,
      content: string,
      closeModal: () => void
    ) => {
      setSaving(true);
      updateWordMutation
        .callMutation({
          giideId,
          recordingID,
          transcriptItemID,
          content,
        })
        .then(result => {
          const parsed = JSON.parse(
            result.data.updateTranscriptContent!.transcript!
          );
          dispatch(setTranscriptData(parsed.items as TranscriptItemInput[]));
          setSaving(false);
          closeModal();
        })
        .catch(err => console.log('ERROR UPDATING TRANSCRIPT WORD: ', err));
    },
    [updateWordMutation, dispatch]
  );

  // React.useEffect(() => {
  //   if (!data || recordingID !== currentRecordID) {
  //     console.log(data, currentRecordID, recordingID);
  //     console.log('Loading transcript data');
  //     setTranscriptData(undefined);
  //     refetch();
  //   }
  // }, [data, refetch, recordingID, currentRecordID]);

  return { data, refetch, loading, updateWord, saving };
};

export default useTranscript;
